// 热议话题数据（示例内容，覆盖娱乐 / 科技 / 生活 / 消费四个频道）

export interface TopicComment {
  user: string;
  tag?: string;
  time: string;
  likes: number;
  side: "支持" | "中立" | "反对" | "围观";
  text: string;
}

export interface Standpoint {
  name: string;
  ratio: number;
  gist: string;
  points: string[];
}

export interface Topic {
  slug: string;
  channel: string; // 频道 slug
  title: string;
  dek: string;
  summary: string;
  image: string;
  tags: string[];
  heat: number; // 热度分
  comments: number; // 参与评论量
  updated: string;
  mood: string[]; // 情绪关键词
  sentiment: { support: number; neutral: number; oppose: number };
  background: string[];
  conclusion: string;
  standpoints: Standpoint[];
  topComments: TopicComment[];
}

export const topics: Topic[] = [
  {
    slug: "reality-show-scripit-reversal",
    channel: "entertainment",
    title: "选秀综艺被质疑「逆袭剧本」，观众却吵翻了",
    dek: "素人选手从淘汰边缘一路翻盘夺冠，到底是大快人心还是剧本安排？",
    summary:
      "一档选秀综艺里人气最高的素人选手在决赛前遭全场「回踩」，大量观众认为夺冠情节太像设计好的剧本；另一批观众则力挺其表现真实。评论区两边人数胶着，情绪值直线上升。",
    image:
      "https://readdy.ai/api/search-image?query=playful%20reality%20tv%20audition%20stage%20with%20spotlight%20microphone%20and%20voting%20cards%2C%20warm%20cream%20background%2C%20coral%20orange%20and%20ink%20tones%2C%20flat%20editorial%20illustration%2C%20drama%20and%20suspense%20mood%2C%20soft%20shadows%2C%20magazine%20style&width=800&height=500&seq=cg-topic-script&orientation=landscape",
    tags: ["选秀", "剧本争议", "逆袭"],
    heat: 9820,
    comments: 12800,
    updated: "约 2 小时前",
    mood: ["怀疑", "惊喜", "争论"],
    sentiment: { support: 46, neutral: 22, oppose: 32 },
    background: [
      "近日一档网络选秀综艺进入决赛周，此前排名靠后的素人选手突然发力，一路闯进前三并有望夺冠，节目热度随之飙升。",
      "随着节目组放出「导师点评 + 花絮切片」，不少网友翻出早期投票数据，质疑存在明显的水分与剧本操作，话题相关讨论量在一小时内突破万条。",
      "与此同时，大量被圈粉的观众晒出自己的真实观看记录，认为选手进步肉眼可见，「努力不被承认才是最气人的」。",
    ],
    conclusion:
      "从汇总数据看，观众并非一边倒。主流声音认为「剧本与否见仁见智」，真正被讨厌的是节目方把观众当傻子；只要呈现真实、不拉踩，逆袭仍然能赢得共情。",
    standpoints: [
      {
        name: "剧情党：坚持是剧本",
        ratio: 32,
        gist: "节奏太完美，反转太丝滑，几乎每一步都踩在节目组的剪辑点上。",
        points: [
          "从淘汰边缘到夺冠的曲线过于顺滑，镜头语言暗示明显。",
          "票数涨幅集中在决赛前一周，缺少路人自然发酵的痕迹。",
          "同组其他选手的「陪跑感」过重，更像是为了衬托主角。",
        ],
      },
      {
        name: "真香党：凭实力翻盘",
        ratio: 46,
        gist: "实力才是硬道理，节目效果不等于剧本。",
        points: [
          "选手高光舞台有完整排练花絮，前后进步可以横向对比。",
          "同期有大量路人现场返图佐证舞台真实完成度。",
          "允许普通人有梦想，不承认努力才会让节目失去意义。",
        ],
      },
      {
        name: "中立派：看个乐就好",
        ratio: 22,
        gist: "不必上纲上线，综艺的本质是情绪价值。",
        points: [
          "愿意看的就是情绪，真不真反而没那么重要。",
          "平台若肯公布后台匿名投票规则，争议自然平息。",
          "与其纠结剧本，不如关注节目捧出来的新人质量。",
        ],
      },
    ],
    topComments: [
      {
        user: "一颗大橙子",
        tag: "路人",
        time: "今天 09:12",
        likes: 3210,
        side: "中立",
        text: "剧本不剧本的见仁见智，我只求节目组别再靠踩别人捧主角，把观众当傻子真的会翻车。",
      },
      {
        user: "追光少年",
        tag: "真香党",
        time: "今天 08:47",
        likes: 1986,
        side: "支持",
        text: "别人火是剧本，我家孩子火就是真努力？双标得也太明显了，舞台表现摆在那呢。",
      },
      {
        user: "八倍镜选手",
        time: "今天 08:05",
        likes: 1452,
        side: "反对",
        text: "投票曲线我看了三遍，前两周几乎不动，决赛周直接起飞，这不是剧本是什么？",
      },
      {
        user: "晚上睡不着",
        time: "昨天 23:18",
        likes: 977,
        side: "围观",
        text: "围观了一圈，两边吵得越凶节目越火，其实赢麻了的是平台。",
      },
    ],
  },
  {
    slug: "idol-acting-mainstream-drama",
    channel: "entertainment",
    title: "偶像扎堆拍正剧，观众到底买不买账？",
    dek: "流量演员进军正剧赛道，是「破圈转型」还是「水土不服」？",
    summary:
      "多位唱跳偶像接连官宣出演年代正剧与悬疑剧，引发「演技能否扛住」的大讨论。支持者认为给年轻演员机会无可厚非，质疑者担心流量稀释剧集质感，话题热度居高不下。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20film%20set%20with%20retro%20camera%20clapperboard%20and%20actor%20silhouette%2C%20warm%20cream%20background%2C%20coral%20and%20brown%20tones%2C%20flat%20editorial%20illustration%2C%20dramatic%20lighting%2C%20soft%20shadows%2C%20film%20review%20mood&width=800&height=500&seq=cg-topic-idol&orientation=landscape",
    tags: ["演技", "正剧", "转型"],
    heat: 8460,
    comments: 9600,
    updated: "约 5 小时前",
    mood: ["期待", "担忧", "观望"],
    sentiment: { support: 54, neutral: 20, oppose: 26 },
    background: [
      "近期几部头部剧组的选角官宣里，接连出现了从偶像组合转型的年轻面孔，题材也从以往的甜宠转向年代群像与悬疑探案。",
      "剧组方称看重的是新人的可塑性与档期配合，而老剧粉则担心角色完成度，直指「正剧不是镀金跳板」。",
      "围绕「流量 + 正剧」能否兼容，评论区演变成演技派粉丝与偶像粉丝的拉锯战。",
    ],
    conclusion:
      "整体而言，观众态度偏开放：机会可以给，但要用作品说话。主流共识是「转型值得鼓励，若拿不出像样表现，消耗的是整个类型剧的口碑」。",
    standpoints: [
      {
        name: "转型支持派",
        ratio: 54,
        gist: "给年轻演员舞台，行业才有活水。",
        points: [
          "谁都是从新人走来的，成熟剧组可以帮忙打磨演技。",
          "正剧需要观众基础，偶像自带的话题对剧集有正向助力。",
          "只要不抢核心角色，客串与配角是可接受的过渡。",
        ],
      },
      {
        name: "品质担忧派",
        ratio: 26,
        gist: "担心流量稀释剧本与制作质感。",
        points: [
          "年代正剧讲究生活质感，偶像脸容易出戏。",
          "片酬与档期常挤占真正适合的演员。",
          "这几年「流量扑街」的先例并不少。",
        ],
      },
      {
        name: "吃瓜中立派",
        ratio: 20,
        gist: "成品出来再评价，拒绝预判。",
        points: [
          "预告片和成片没出来，下结论都为时过早。",
          "更关心编剧和导演能不能把故事讲好。",
        ],
      },
    ],
    topComments: [
      {
        user: "老剧粉阿凯",
        time: "今天 11:40",
        likes: 2750,
        side: "反对",
        text: "不是反对新人，是反对把正剧当镀金跳板。尊重一下题材，先从小角色演起不行吗？",
      },
      {
        user: "舞台钉子户",
        time: "今天 10:58",
        likes: 2310,
        side: "支持",
        text: "我家担为了这个角色提前三个月进组练台词，怎么到你们嘴里就成一无是处了？",
      },
      {
        user: "追剧狂人",
        time: "今天 09:32",
        likes: 1680,
        side: "中立",
        text: "说再多不如看正片，演技这东西拿两集出来比啥都强。",
      },
      {
        user: "清醒的吃瓜",
        time: "昨天 22:05",
        likes: 902,
        side: "围观",
        text: "话题越吵，剧越有热度，这波无论谁赢，平台先赢。",
      },
    ],
  },
  {
    slug: "slow-tv-travel-trend",
    channel: "entertainment",
    title: "慢综艺「同款房车」意外带火冷门旅行地",
    dek: "一档露营慢综艺让三线小城排起长队，网红效应是福是祸？",
    summary:
      "节目里的同款房车路线被网友逐一扒出，原本冷门的小城驿站突然爆火。有人直呼节目救活小城，也有人担心过度打卡透支当地体验。",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20campervan%20campsite%20by%20lakeside%20with%20tent%20bonfire%20and%20stars%2C%20warm%20cream%20and%20coral%20sunset%20tones%2C%20flat%20editorial%20illustration%2C%20relaxing%20slow%20travel%20mood%2C%20soft%20shadows%2C%20magazine%20style&width=800&height=500&seq=cg-topic-travel&orientation=landscape",
    tags: ["慢综艺", "旅行", "打卡"],
    heat: 6280,
    comments: 5400,
    updated: "昨天 18:20",
    mood: ["心动", "担忧", "期待"],
    sentiment: { support: 61, neutral: 24, oppose: 15 },
    background: [
      "一档主打房车露营的慢综艺播出后，嘉宾路过的临湖小驿站与野营地成为网友打卡焦点，国庆前后本地民宿预订量明显上涨。",
      "大量观众按图索骥「复制同款路线」，当地文旅部门顺势推出主题手绘地图，也加入这波流量。",
      "随着人流增多，部分网友开始担心小城承载能力与「滤镜后遗症」。",
    ],
    conclusion:
      "多数网友为节目带火小城叫好，认为这是文旅与内容的双赢；同时呼吁理性打卡、尊重本地节奏，避免网红经济反噬平静生活。",
    standpoints: [
      {
        name: "带火派",
        ratio: 61,
        gist: "好内容就该带动好地方。",
        points: [
          "为无人问津的小城带来真实客流与就业机会。",
          "节目选点审美在线，值得被更多人看见。",
          "相比网红流水线，这种慢生活反而更可持续。",
        ],
      },
      {
        name: "冷静派",
        ratio: 24,
        gist: "热闹之后更要守住体验。",
        points: [
          "短时流量容易被平台搬运放大，形成跟风。",
          "小城基建未必扛得住周末峰值人流。",
        ],
      },
      {
        name: "担忧派",
        ratio: 15,
        gist: "担心滤镜与现实落差。",
        points: [
          "同款机位拍完就走，真正的小城生活没人关心。",
          "过度商业化会破坏原本的松弛感。",
        ],
      },
    ],
    topComments: [
      {
        user: "背包客小鹿",
        time: "昨天 21:12",
        likes: 1890,
        side: "支持",
        text: "那湖边真的美哭，节目组选点是真的懂，小城值得被看见！",
      },
      {
        user: "本地人老王",
        time: "昨天 20:35",
        likes: 1420,
        side: "中立",
        text: "周末是真的人多了，希望大家轻点踩，我们这本来就安安静静挺好。",
      },
      {
        user: "理性种草机",
        time: "昨天 19:44",
        likes: 1105,
        side: "反对",
        text: "别全信滤镜，真去了发现和节目里差不少，心态放平再来。",
      },
    ],
  },
  {
    slug: "ai-tools-review-debate",
    channel: "tech",
    title: "AI 办公工具评测「口水战」，到底在吵什么？",
    dek: "从提效神器到带节奏割韭菜，同一款工具被两头夸两头骂。",
    summary:
      "多款国产 AI 办公助手集中上线，博主测评两极分化：有人说省下半天工时，有人说只是换了个地方加班。争议背后其实是「工具 vs 使用方式」的老问题。",
    image:
      "https://readdy.ai/api/search-image?query=futuristic%20desk%20with%20laptop%20robot%20assistant%20and%20floating%20document%20holograms%2C%20warm%20cream%20background%2C%20coral%20and%20sage%20tones%2C%20flat%20editorial%20illustration%2C%20modern%20tech%20mood%2C%20soft%20shadows%2C%20clean%20minimal&width=800&height=500&seq=cg-topic-ai&orientation=landscape",
    tags: ["AI", "办公工具", "效率"],
    heat: 10500,
    comments: 14300,
    updated: "约 1 小时前",
    mood: ["兴奋", "疑虑", "好奇"],
    sentiment: { support: 58, neutral: 26, oppose: 16 },
    background: [
      "近一个月，数款主打文档、表格、会议纪要的 AI 办公助手密集发布，各家都以「替你干活」为卖点。",
      "头部科技博主的实测视频却出现冰火两重天：一类惊呼生成报告只需三分钟，另一类直指结论依赖提示词、容易「一本正经胡说八道」。",
      "评论区由此分裂成「效率派」与「质疑派」，甚至上升到对博主恰饭与立场的人身猜测。",
    ],
    conclusion:
      "把声音拉平看，真正争执的并非工具好坏，而是「是否把 AI 当全能员工」。主流共识是：AI 是放大器，前提是你得先能判断它给的东西对不对。",
    standpoints: [
      {
        name: "效率派",
        ratio: 58,
        gist: "重复劳动交给 AI，人只负责判断。",
        points: [
          "会议纪要与周报这类结构化内容确实省时省力。",
          "好的提示词模板让产出质量翻倍。",
          "用不上说明方式没对，不是工具没用。",
        ],
      },
      {
        name: "质疑派",
        ratio: 16,
        gist: "所谓提效，可能只是让你更快地卷。",
        points: [
          "产出要逐条核对，省下的时间又花在验收上。",
          "生成内容版权与数据安全仍存隐患。",
          "工具越聪明，越是把人绑得更紧。",
        ],
      },
      {
        name: "清醒派",
        ratio: 26,
        gist: "工具本身无罪，别被营销带节奏。",
        points: [
          "看测评要盯着「同一任务下的可复现结果」。",
          "免费试用一周再决定，别冲动年付。",
        ],
      },
    ],
    topComments: [
      {
        user: "打工人小赵",
        time: "今天 13:22",
        likes: 4021,
        side: "支持",
        text: "用它写周报是真的快，剩下时间摸鱼它不香吗？",
      },
      {
        user: "代码老哥",
        time: "今天 12:58",
        likes: 2870,
        side: "反对",
        text: "上周让它总结会议，直接把骂老板那段也写进纪要了，谁懂啊。",
      },
      {
        user: "产品经理Mia",
        time: "今天 11:47",
        likes: 2330,
        side: "中立",
        text: "工具是放大器，前提是你得知道什么是正确答案。别神化也别妖魔化。",
      },
      {
        user: "数码透明人",
        time: "今天 10:16",
        likes: 1566,
        side: "围观",
        text: "吵到最后，赢的永远是发测评视频的博主。",
      },
    ],
  },
  {
    slug: "foldable-phone-price-war",
    channel: "tech",
    title: "国产折叠屏价格战，把「尝鲜」打成「普及」？",
    dek: "万元折叠屏跌破六千，是捡漏的好时机还是噱头营销？",
    summary:
      "多家厂商接连下调折叠屏主力机型售价，中端线也开始铺货。有人觉得折叠屏终于到了能入手的节点，也有人担心降价背后是库存与成熟度问题。",
    image:
      "https://readdy.ai/api/search-image?query=foldable%20smartphone%20half%20open%20floating%20with%20glowing%20screen%20and%20sparkles%2C%20warm%20cream%20background%2C%20coral%20orange%20and%20teal%20accents%2C%20flat%20editorial%20illustration%2C%20premium%20tech%20mood%2C%20soft%20shadows%2C%20clean%20minimal&width=800&height=500&seq=cg-topic-fold&orientation=landscape",
    tags: ["折叠屏", "价格", "手机"],
    heat: 7740,
    comments: 6900,
    updated: "约 3 小时前",
    mood: ["心动", "观望", "质疑"],
    sentiment: { support: 47, neutral: 33, oppose: 20 },
    background: [
      "继多家旗舰折叠屏在电商大促「跳水」后，今年更多品牌把入门折叠机型的价格拉到六千元区间，宣传口径也从「商务旗舰」转向「年轻人的第一台折叠屏」。",
      "降价带动了讨论热度，但关于铰链耐用性、售后维修成本的担忧也随之而来。",
      "行业观察认为，这轮价格战背后是供应链成熟后的主动放量，也是厂商抢占换机窗口的策略。",
    ],
    conclusion:
      "整体态度偏积极但克制：降价确实拉近了与大众的距离，主流建议是「等首批评测、认准铰链与售后，再决定冲不冲」，别只看价格冲动入手。",
    standpoints: [
      {
        name: "捡漏党",
        ratio: 47,
        gist: "这个价格，折叠屏终于可以无脑冲。",
        points: [
          "同配置下横向对比，性价比已接近直板旗舰。",
          "折叠形态的多任务体验确实有不可替代性。",
          "早买早享受，晚买享折扣，现在正是折扣期。",
        ],
      },
      {
        name: "观望派",
        ratio: 33,
        gist: "降价不是理由，成熟才是。",
        points: [
          "铰链寿命与折痕控制要等长期使用反馈。",
          "折叠屏维修成本高，便宜不代表养得起。",
          "明年技术迭代快，不急这一时。",
        ],
      },
      {
        name: "唱衰派",
        ratio: 20,
        gist: "降价掩盖不了小众本质。",
        points: [
          "多数人用不到折叠，图个新鲜而已。",
          "大幅降价往往伴随清库存。",
        ],
      },
    ],
    topComments: [
      {
        user: "数码极客L",
        time: "今天 14:03",
        likes: 2540,
        side: "支持",
        text: "这个价能买到展开大屏，办公和看剧是真香，已下单。",
      },
      {
        user: "修机师傅",
        time: "今天 13:40",
        likes: 2010,
        side: "反对",
        text: "听劝，先看铰链再看价格，修一次屏幕能买台直板旗舰。",
      },
      {
        user: "理性消费者",
        time: "今天 12:20",
        likes: 1670,
        side: "中立",
        text: "降价是好事，但请把「降噪」了的价格当首发价看待，别被大促节奏牵着走。",
      },
    ],
  },
  {
    slug: "phone-moon-photography",
    channel: "tech",
    title: "「拍月亮」又上热搜：手机成像是算出来的，算作弊吗？",
    dek: "当手机月亮照靠 AI 补全细节，用户该不该被告知？",
    summary:
      "有网友发现某旗舰机拍月亮会调用算法补全环形山细节，引发「这叫拍摄还是生成」的争论。手机影像团队则解释这是计算摄影的一部分。",
    image:
      "https://readdy.ai/api/search-image?query=smartphone%20silhouette%20pointing%20at%20big%20crescent%20moon%20in%20night%20sky%20with%20stars%2C%20warm%20coral%20and%20ink%20night%20tones%2C%20flat%20editorial%20illustration%2C%20dreamy%20contemplative%20mood%2C%20soft%20glow%2C%20clean%20minimal&width=800&height=500&seq=cg-topic-moon&orientation=landscape",
    tags: ["手机", "计算摄影", "月亮"],
    heat: 5290,
    comments: 4700,
    updated: "昨天 22:40",
    mood: ["惊讶", "好奇", "争议"],
    sentiment: { support: 40, neutral: 30, oppose: 30 },
    background: [
      "一名数码博主在夜晚实测中发现，同一机型在拍摄月亮时，暗部环形山细节会自动「脑补」得比直出更完整，遂将其称为「AI 修月亮」。",
      "厂商随后说明，这是多帧合成与场景识别的常规计算摄影逻辑，并非凭空捏造，但也承认与「所见即所得」存在差异。",
      "围绕「成像边界」的讨论迅速扩散到整个手机摄影圈，连风景照的算法增强也被重新审视。",
    ],
    conclusion:
      "舆论并非要讨伐技术本身，而是要求「知情」。主流声音认为：用 AI 让照片更好看没问题，但应用户清楚哪些是算法补出来的，避免把「算出来的」误认为「拍出来的」。",
    standpoints: [
      {
        name: "宽容派",
        ratio: 40,
        gist: "计算摄影本就是行业共识。",
        points: [
          "多帧合成、夜景降噪都是算法，早已是标配。",
          "拍月亮加细节与美白修图逻辑一致。",
          "能让普通用户拍出好看照片，何乐不为。",
        ],
      },
      {
        name: "较真派",
        ratio: 30,
        gist: "真实与生成必须有边界。",
        points: [
          "纪实场景应标注算法介入程度。",
          "防止「眼见为实」被技术架空。",
        ],
      },
      {
        name: "路过派",
        ratio: 30,
        gist: "好看就行，别上纲上线。",
        points: [
          "手机不是相机，没人在乎严苛原图。",
          "厂商说明清楚即可，用户有选择权。",
        ],
      },
    ],
    topComments: [
      {
        user: "夜拍爱好者",
        time: "昨天 23:50",
        likes: 1720,
        side: "反对",
        text: "不是不能修，而是得告诉我修了。打着「直出」的旗号卖点就不厚道。",
      },
      {
        user: "科技观察员",
        time: "昨天 23:21",
        likes: 1480,
        side: "中立",
        text: "真要较真，HDR、防抖、多帧合成哪个不是算法？边界其实一直模糊。",
      },
      {
        user: "随手拍党",
        time: "昨天 22:55",
        likes: 1130,
        side: "支持",
        text: "能拍出朋友圈九图我就满足，厂商把话说清楚就行。",
      },
    ],
  },
  {
    slug: "cycling-vs-car-commute",
    channel: "life",
    title: "通勤到底骑车还是开车？打工人评论区吵到飞起",
    dek: "同一条路线，有人 20 分钟到，有人堵到怀疑人生。",
    summary:
      "一位打工人晒出「骑车 vs 打车」通勤对比视频走红：骑车 25 分钟、开车 40 分钟起步，评论区随即演变成通勤方式大论战，还牵扯出安全、体面与成本之争。",
    image:
      "https://readdy.ai/api/search-image?query=bicycle%20and%20car%20side%20by%20side%20on%20city%20morning%20street%20with%20traffic%20light%2C%20warm%20cream%20and%20coral%20tones%2C%20flat%20editorial%20illustration%2C%20commute%20energy%2C%20soft%20shadows%2C%20cheerful%20city%20life%20mood&width=800&height=500&seq=cg-topic-cycle&orientation=landscape",
    tags: ["通勤", "骑行", "生活方式"],
    heat: 8950,
    comments: 11200,
    updated: "约 4 小时前",
    mood: ["共鸣", "自嘲", "坚定"],
    sentiment: { support: 52, neutral: 27, oppose: 21 },
    background: [
      "随着共享单车与城市绿道完善，越来越多上班族开始「4 + 2」或全程骑行通勤。一条实测视频让两种方式的支持者正面交锋。",
      "骑车党强调时间可控、顺便锻炼还能省停车费；开车党则诉苦早晚高峰路况、雨天体验与通勤距离的现实。",
      "话题顺势延伸出「通勤自由」「体面出行」等讨论，评论区共鸣强烈。",
    ],
    conclusion:
      "没有谁对谁错，结论是「因地制宜」。主流共识：距离在十公里内、路况尚可，骑车是更聪明的选择；真要兼顾家人与远距，别为体面硬扛，安全与舒适才是底线。",
    standpoints: [
      {
        name: "骑行党",
        ratio: 52,
        gist: "时间自由，身体也跟着变好。",
        points: [
          "拥堵路段骑车基本能做到时间稳定。",
          "顺便把健身卡省了，一天下来精神头更足。",
          "停车费、油费一算，一年能省不少。",
        ],
      },
      {
        name: "开车党",
        ratio: 21,
        gist: "远距离与天气面前，骑车太理想化。",
        points: [
          "通勤二十公里还骑车，到公司先废一半。",
          "雨天、高温、夜路的安全隐患被忽略。",
          "需要接送家人时，车仍是刚需。",
        ],
      },
      {
        name: "混搭派",
        ratio: 27,
        gist: "别二选一，组合才是最优解。",
        points: [
          "地铁加共享单车，或者开车到外围换乘。",
          "关键是缩短「纯等待」时间而非纠结交通工具。",
        ],
      },
    ],
    topComments: [
      {
        user: "北三环打工人",
        time: "今天 16:20",
        likes: 3650,
        side: "支持",
        text: "骑了两年，从胖子变成匀称了，重点是再也不用看红灯焦躁。",
      },
      {
        user: "二胎爸爸",
        time: "今天 15:47",
        likes: 2410,
        side: "反对",
        text: "送完娃再上班，你让我骑车？先看看啥叫生活再说吧。",
      },
      {
        user: "地铁达人",
        time: "今天 14:58",
        likes: 1930,
        side: "中立",
        text: "同城不同命，先谈距离再谈方式，别拿你的通勤丈量所有人。",
      },
      {
        user: "精致穷女孩",
        time: "今天 14:10",
        likes: 1280,
        side: "围观",
        text: "我骑车主要是穷，顺便健康，这波算自我安慰成功了。",
      },
    ],
  },
  {
    slug: "buddy-culture-longterm",
    channel: "life",
    title: "「搭子文化」卷土重来：长期饭搭子到底该不该找？",
    dek: "从饭搭子到健身搭子，年轻人的关系越来越「轻」。",
    summary:
      "继去年「饭搭子」走红后，今年出现了追求稳定性的「长期搭子」。有人觉得轻量社交解压又自由，也有人担心把关系工具化会越来越孤独。",
    image:
      "https://readdy.ai/api/search-image?query=two%20young%20friends%20eating%20noodles%20together%20at%20warm%20cafe%20table%2C%20warm%20cream%20and%20coral%20tones%2C%20flat%20editorial%20illustration%2C%20cozy%20social%20mood%2C%20soft%20shadows%2C%20friendly%20and%20lighthearted%20atmosphere&width=800&height=500&seq=cg-topic-buddy&orientation=landscape",
    tags: ["搭子文化", "社交", "年轻人"],
    heat: 6680,
    comments: 5900,
    updated: "昨天 16:30",
    mood: ["轻松", "反思", "认同"],
    sentiment: { support: 63, neutral: 22, oppose: 15 },
    background: [
      "「搭子」指按需匹配、随时可散的轻量社交伙伴。近期出现追求固定搭档的「长期饭搭子」「健身搭子」，年轻人开始为一件事绑定一段关系。",
      "支持者认为轻关系规避了人情债，让社交回归「有事相帮、无事自由」；反对者担心长期搭子会让深层友谊更难建立。",
      "话题在多个城市社群发酵，也带出关于独居青年的心理健康讨论。",
    ],
    conclusion:
      "主流态度是「分寸感万岁」：搭子文化不是要取代友情，而是给快节奏生活提供补充。真正被推崇的是既能合拍、又能互不打扰的关系边界。",
    standpoints: [
      {
        name: "轻量社交派",
        ratio: 63,
        gist: "按需相处，快乐翻倍、负担为零。",
        points: [
          "不用迁就全部时间表，只对共同兴趣负责。",
          "避免朋友间的礼物、往来人情压力。",
          "长期搭子还能形成稳定的小习惯。",
        ],
      },
      {
        name: "关系顾虑派",
        ratio: 15,
        gist: "过度工具化会让人更孤单。",
        points: [
          "处处按功能分人，可能弱化深度连接。",
          "搭子终究替代不了被真正理解。",
        ],
      },
      {
        name: "平衡派",
        ratio: 22,
        gist: "搭子与挚友可以共存。",
        points: [
          "轻关系帮忙撑住日常，深关系留在心里。",
          "关键是分清需求，不把搭子当情感替代。",
        ],
      },
    ],
    topComments: [
      {
        user: "沪上打工人",
        time: "昨天 18:02",
        likes: 2870,
        side: "支持",
        text: "饭搭子拯救了我的午饭孤独，比同事关系舒服多了。",
      },
      {
        user: "社恐本恐",
        time: "昨天 17:33",
        likes: 1990,
        side: "中立",
        text: "能找到合拍的长期搭子其实很难，缘分到了才有。",
      },
      {
        user: "心理学在读生",
        time: "昨天 16:55",
        likes: 1540,
        side: "反对",
        text: "功能化每一段关系，最后可能连情绪都不知道找谁倾诉。",
      },
    ],
  },
  {
    slug: "night-school-youth-revival",
    channel: "life",
    title: "夜校一夜爆火：年轻人的「精神夜宵」能吃多久？",
    dek: "299 元十节课的夜校抢破头，是精神刚需还是社交新宠？",
    summary:
      "主打便宜、有趣的「青年夜校」在多个城市一票难求，非遗手作、脱口秀、书法课迅速被约满。年轻人把它当成对抗无聊与孤独的出口，也引发「会不会又是一阵风」的讨论。",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20night%20classroom%20with%20students%20learning%20calligraphy%20and%20pottery%20under%20warm%20lamp%2C%20warm%20cream%20and%20coral%20tones%2C%20flat%20editorial%20illustration%2C%20inspiring%20self%20improvement%20mood%2C%20soft%20shadows%2C%20community%20feeling&width=800&height=500&seq=cg-topic-nightschool&orientation=landscape",
    tags: ["夜校", "青年", "兴趣"],
    heat: 6110,
    comments: 5200,
    updated: "昨天 20:15",
    mood: ["心动", "治愈", "好奇"],
    sentiment: { support: 66, neutral: 25, oppose: 9 },
    background: [
      "今年以来，多座城市的「市民夜校 / 青年夜校」报名系统频繁被挤爆，一些热门课程上线几分钟即满员，黄牛甚至开始代抢名额。",
      "低价、离家近、老师专业是它走红的三板斧，参与者也从上班族扩展到学生与退休人群。",
      "与此同时，出现「课程同质化」「难抢」等声音，质疑热度能否沉淀成常态。",
    ],
    conclusion:
      "网友普遍为夜校「接地气地把兴趣还给人」叫好，认为只要价格与内容经得起考验，这阵风就有机会变成长期习惯；真正的挑战在于后续供给能不能跟上热情。",
    standpoints: [
      {
        name: "精神刚需派",
        ratio: 66,
        gist: "下班后的兴趣是成年人的充电。",
        points: [
          "低价让试错成本极低，普通人也能玩艺术。",
          "线下相聚缓解了「电子生活」的孤独感。",
          "学门手艺比刷短视频更让人有获得感。",
        ],
      },
      {
        name: "理性派",
        ratio: 25,
        gist: "热度要沉淀成好内容。",
        points: [
          "别被一票难求带成新一轮跟风消费。",
          "更关注课程质量与师资，而非拍照打卡。",
        ],
      },
      {
        name: "观望派",
        ratio: 9,
        gist: "先看是不是一阵风。",
        points: [
          "此前不少兴趣班热潮都在降温。",
          "若供给跟不上的热潮难持续。",
        ],
      },
    ],
    topComments: [
      {
        user: "新晋陶艺生",
        time: "昨天 22:10",
        likes: 2430,
        side: "支持",
        text: "报上了陶艺课，299 元十节，比健身房划算，下班有盼头了。",
      },
      {
        user: "北漂十年",
        time: "昨天 21:40",
        likes: 1770,
        side: "中立",
        text: "抢课比抢演唱会还难，看来精神生活是真刚需。",
      },
      {
        user: "课程出品人",
        time: "昨天 20:48",
        likes: 1210,
        side: "支持",
        text: "作为从业者，看到年轻人愿意为兴趣付费，比什么都开心。",
      },
    ],
  },
  {
    slug: "coffee-9yuan-era",
    channel: "consumer",
    title: "连锁咖啡进入「9.9 时代」，品质会崩盘吗？",
    dek: "当咖啡比奶茶还便宜，打工人的快乐与隐忧同时放大。",
    summary:
      "多家连锁咖啡品牌把一杯咖啡的价格打到 9.9 元，并竞相加入会员大战。消费者一边喊「咖啡自由」，一边担忧价格战会透支供应链与品质。",
    image:
      "https://readdy.ai/api/search-image?query=stack%20of%20coffee%20cups%20with%20price%20tag%209.9%20and%20coffee%20beans%20on%20warm%20cream%20background%2C%20coral%20and%20caramel%20tones%2C%20flat%20editorial%20illustration%2C%20friendly%20value%20shopping%20mood%2C%20soft%20shadows%2C%20clean%20minimal&width=800&height=500&seq=cg-topic-coffee&orientation=landscape",
    tags: ["咖啡", "价格战", "消费"],
    heat: 9230,
    comments: 9800,
    updated: "约 3 小时前",
    mood: ["真香", "担忧", "纠结"],
    sentiment: { support: 55, neutral: 25, oppose: 20 },
    background: [
      "年初至今，主流现磨咖啡连锁相继把核心款定价压到十元以内，并推出高频次会员券，价格战从一线打到下沉市场。",
      "消费者体验明显分化：有人点赞「一天两杯无压力」，也有人反馈个别门店出杯速度与品控波动。",
      "行业内讨论则集中在「靠补贴换规模是否可持续」「小店与精品咖啡被挤压」等问题。",
    ],
    conclusion:
      "多数消费者乐见价格回归理性，但强调「便宜别以难喝和慢为代价」。主流期待是价格战倒逼供应链提效，而不是靠牺牲原料与门店体验硬撑。",
    standpoints: [
      {
        name: "真香派",
        ratio: 55,
        gist: "九块九能喝到现磨，还要啥自行车。",
        points: [
          "价格降下来，口粮咖啡才真正大众化。",
          "连锁拼供应链，最终受益的是消费者。",
          "卷起来才有人认真做好喝又便宜的咖啡。",
        ],
      },
      {
        name: "品质担忧派",
        ratio: 20,
        gist: "便宜背后可能是压缩成本。",
        points: [
          "降价常常伴随豆子与出杯标准的下调。",
          "门店人效压力大，服务体验会打折扣。",
          "长期补贴难以为继，最终可能反噬。",
        ],
      },
      {
        name: "中立派",
        ratio: 25,
        gist: "看人下菜，各有各的市场。",
        points: [
          "9.9 元是通勤刚需，精品店卖的是体验与空间。",
          "两类客群不同，不必然互斥。",
        ],
      },
    ],
    topComments: [
      {
        user: "咖啡续命族",
        time: "今天 15:12",
        likes: 3890,
        side: "支持",
        text: "以前一天一杯肉疼，现在早上一杯下午一杯，快乐翻倍。",
      },
      {
        user: "前咖啡师",
        time: "今天 14:38",
        likes: 2210,
        side: "反对",
        text: "豆子和奶成本摆在那，九块九能给你什么好料，心里没数吗？",
      },
      {
        user: "理性买手",
        time: "今天 13:55",
        likes: 1650,
        side: "中立",
        text: "低价的快乐和品质的担忧可以同时存在，关键是别只盯着价格标签。",
      },
    ],
  },
  {
    slug: "young-reverse-consumption",
    channel: "consumer",
    title: "年轻人开始「反向消费」，只买平替不买大牌了？",
    dek: "大牌平替、二手闲置、临期捡漏……这届年轻人把省字玩明白了。",
    summary:
      "越来越多年轻消费者晒出自己的「反向消费」账单：同厂平替、二手循环、临期好物成为新的省钱美学。省钱背后，是消费观从「牌子」转向「实用」的集体转向。",
    image:
      "https://readdy.ai/api/search-image?query=smart%20budget%20shopping%20flat%20lay%20with%20dupe%20products%20receipt%20and%20piggy%20bank%20on%20warm%20cream%20background%2C%20coral%20and%20caramel%20tones%2C%20flat%20editorial%20illustration%2C%20smart%20saving%20mood%2C%20soft%20shadows%2C%20clean%20minimal&width=800&height=500&seq=cg-topic-reverse&orientation=landscape",
    tags: ["反向消费", "平替", "省钱"],
    heat: 8120,
    comments: 7400,
    updated: "今天 08:20",
    mood: ["清醒", "认同", "得意"],
    sentiment: { support: 74, neutral: 18, oppose: 8 },
    background: [
      "「不是大牌买不起，而是平替更有性价比」成为社交平台的流行梗。年轻消费者开始热衷研究同源供应链与成分表，理性消费逐渐成主流叙事。",
      "二手平台活跃用户与临期食品店的兴起，让「会省」成为一种被认同的能力与生活方式。",
      "与此同时，也有声音提醒别陷入「为省而省」的另一种消费主义。",
    ],
    conclusion:
      "这是近几个月舆论最一边倒的话题之一。主流共识：把钱花在真实需求上、不再为品牌溢价买单，值得肯定；但省钱的目标应是生活品质，而不是把自己过成计算器。",
    standpoints: [
      {
        name: "务实派",
        ratio: 74,
        gist: "为价值买单，不为 logo 买单。",
        points: [
          "成分、做工、效果拉齐，平替就是最优解。",
          "二手循环让闲置流动起来，环保又省钱。",
          "会花钱更会省，是一种生活能力。",
        ],
      },
      {
        name: "提醒派",
        ratio: 8,
        gist: "别把省钱变成新的焦虑。",
        points: [
          "过度比价会消耗大量时间与精力。",
          "低价平替品质参差，踩雷成本并不低。",
        ],
      },
      {
        name: "平衡派",
        ratio: 18,
        gist: "看需求定，不必非黑即白。",
        points: [
          "天天用的买好点，偶尔尝鲜再图便宜。",
          "关键是清楚自己要什么。",
        ],
      },
    ],
    topComments: [
      {
        user: "极简主义者",
        time: "今天 09:02",
        likes: 3010,
        side: "支持",
        text: "自从学会看成分和同厂，我的月消费直接腰斩，还没觉得降级。",
      },
      {
        user: "踩雷小王",
        time: "今天 08:44",
        likes: 1330,
        side: "反对",
        text: "平替十次踩雷三次，最后算下来也没省多少，还搭上时间。",
      },
      {
        user: "二手淘客",
        time: "昨天 23:30",
        likes: 1180,
        side: "支持",
        text: "九成新的大牌闲置半价到手，真香。循环起来。",
      },
    ],
  },
  {
    slug: "silver-tour-group-buying",
    channel: "consumer",
    title: "银发团游被年轻人「反向拼团」？代买服务走红引热议",
    dek: "低价的老年旅行团，被年轻人发现「真香」并加入代买潮。",
    summary:
      "有网友发现部分低价银发团含金量意外地高，行程慢、餐标足、领队耐心，于是开始尝试并带动「代长辈报名 / 反向跟团」风潮，同时也引发适老化消费边界的讨论。",
    image:
      "https://readdy.ai/api/search-image?query=seniors%20and%20young%20people%20touring%20together%20with%20camera%20and%20suitcase%20near%20scenic%20arch%2C%20warm%20cream%20and%20coral%20tones%2C%20flat%20editorial%20illustration%2C%20happy%20mixed%20generation%20travel%20mood%2C%20soft%20shadows%2C%20friendly%20vibe&width=800&height=500&seq=cg-topic-senior&orientation=landscape",
    tags: ["银发经济", "旅行", "代购"],
    heat: 4480,
    comments: 3900,
    updated: "昨天 11:00",
    mood: ["好奇", "认同", "担忧"],
    sentiment: { support: 58, neutral: 30, oppose: 12 },
    background: [
      "一则「年轻人反向报名银发旅行团」的帖子走红，作者分享低价团里几乎没有强制购物、节奏轻松，评论区随即涌入大量求链接与「求代报名」的回复。",
      "部分旅社顺势推出「代长辈下单」「家庭慢游」标签，也有商家开始警惕被钻低价政策的空子。",
      "围绕「银发团到底能不能卖给年轻人」，平台与旅社态度不一，讨论持续升温。",
    ],
    conclusion:
      "网友的兴奋更多来自「终于有对老年游客友好的好产品」。主流观点是：与其讨论该不该反向拼团，不如推动市场提供更多「慢下来、不坑人」的旅行选择，让好产品造福所有人。",
    standpoints: [
      {
        name: "尝鲜派",
        ratio: 58,
        gist: "好产品不该被年龄标签锁死。",
        points: [
          "低价又能慢游，谁能拒绝？",
          "替爸妈筛选靠谱团，是种新型孝心。",
          "年轻人加入也能反向监督服务质量。",
        ],
      },
      {
        name: "规则派",
        ratio: 12,
        gist: "担心挤占适老资源。",
        points: [
          "银发团有政府补贴与适老设计，被年轻人占用不妥。",
          "低价团面向老人的坑依然存在。",
        ],
      },
      {
        name: "中立派",
        ratio: 30,
        gist: "热闹归热闹，报名要看清楚条款。",
        points: [
          "留意购物点与保险条款，别只盯低价。",
          "让好产品供给变多是根本。",
        ],
      },
    ],
    topComments: [
      {
        user: "孝心放大器",
        time: "昨天 12:30",
        likes: 2120,
        side: "支持",
        text: "给爸妈报名前先自己跟团踩线，是我做过最值的事。",
      },
      {
        user: "旅社老总",
        time: "昨天 12:02",
        likes: 1580,
        side: "中立",
        text: "年轻人反向跟团我们欢迎，但请把低价背后的条款看仔细，别最后骂我们坑。",
      },
      {
        user: "背包侠客",
        time: "昨天 11:36",
        likes: 960,
        side: "支持",
        text: "陪爸妈报名一次，发现慢游真香，已经计划第三次了。",
      },
    ],
  },
];